<!-- 资料库-->
<template>
  <div class="upload-assets__wrapper">
    <upload
      class="assets-uploader"
      action=""
      :show-file-list="false"
      :http-request="uploadRequest"
      accept=".ico,.png,.gif,.jpg,.jpeg"
      :multiple="true"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <upload-trigger :text="uploadText || $t('upload.text')" :tip="tip || $t('upload.limit',{limit})" :suggestion="suggestion"></upload-trigger>
    </upload>
    <compress-image-tip
      v-if="pendingFile"
      :limit="limit"
      :file-name="pendingFile.name"
      @confirm="onConfirmCompress"
      @cancel="onCancelCompress" />
    <div :class="['upload-list__wrapper mt-8px', {
      'overflow-widget': inWidget
    }]">
      <upload-list :data="assetsList" :in-widget="inWidget" :current-url="value" @delete="deleteMethod" @change="changeCheckedMethod"></upload-list>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash-es'
import { mapState } from 'vuex'
import { Upload, Message } from 'element-ui'
import UploadList from './upload/uploadList'
import UploadTrigger from './upload/uploadTrigger'
import { useAssets } from '~/hooks/useAssets'
import CompressImageTip from '~/site/components/compressImageTip'
import { compressImage } from '~/utils/imageCompress'

export default {
  name: "AssetsMaterial",
  components: {
    Upload,
    UploadList,
    UploadTrigger,
    CompressImageTip
  },
  model: {
    prop: 'value:',
    event: 'change'
  },
  props: {
    uploadText: {
      type: String,
      default: ''
    },
    inWidget: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 2 // 2Mb
    },
    suggestion: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    const { assetsList, uploadFileRequest, deleteAssetsByUrl, getAssets } = useAssets(this)
    return {
      imageUrl: '',
      assetsList,
      uploadFileRequest,
      deleteAssetsByUrl,
      getAssets,
      pendingFile: null,
      compressResolver: null
    }
  },
  computed: {
    ...mapState({
      projectId: state => state.project.projectId,
      merchantId: state => state.project.merchantId,
      domain: state => state.project.domain,
    })
  },
  created() {
    this.throttleGetAssets = throttle(this.getAssets, 1500)
    // this.getAssets(this.domain, this.merchantId, this.projectId)
  },
  methods: {
    init() {
      this.throttleGetAssets(this.domain, this.merchantId, this.projectId)
    },
    // getAssetsList() {
    //   this.$api.assets.getAssets({directory: this.$route.pid || 'test', merchant_id: 9,project_id: 12}).then(res=>{
    //     const data = res.data || []
    //     this.__assetsList = data
    //     this.assetsList = data.map((item => item.url))
    //   })
    // },
    deleteMethod(imgUrl) {
      this.deleteAssetsByUrl(imgUrl)
    },
    changeCheckedMethod(imgUrl) {
      this.$emit('change', imgUrl)
    },
    uploadRequest(options) {
      const formData = new FormData();
      this.assetsList.unshift({
        uid: options.file.uid,
        loading: true
      })
      const user = this.$cookies.get('userInfo')
      formData.set('operator', user?.id || '')
      formData.append('file', options.file)
      formData.append('merchant_id', this.merchantId)
      formData.append('project_id', this.projectId)
      formData.append('directory', this.domain)
      this.uploadFileRequest(formData).then(res => {
        const index = this.assetsList.findIndex(asset => asset?.uid === options.file.uid)
        if (index < 0) {
          options.onError();
          return
        }
        this.$set(this.assetsList, index, {
          ...this.assetsList[index],
          url: res.url,
          loading: false
        })
        this.throttleGetAssets(this.domain, this.merchantId, this.projectId)
        options.onSuccess(res);
      }).catch(() => {
        const index = this.assetsList.findIndex(asset => asset?.uid === options.file.uid)
        this.assetsList.splice(index, 1)
        options.onError();
      })
    },
    handleAvatarSuccess(res, file) {
      //
    },
    beforeAvatarUpload(file) {
      const isLtM = file.size / 1024 / 1024 < this.limit;
      if (isLtM) {
        return true
      }
      // 超限：内联提示，确认压缩后 resolve 压缩文件，取消则 reject 终止上传
      this.pendingFile = file
      return new Promise((resolve, reject) => {
        this.compressResolver = { resolve, reject }
      })
    },
    onConfirmCompress() {
      const resolver = this.compressResolver
      const file = this.pendingFile
      this.compressResolver = null
      this.pendingFile = null
      if (!resolver || !file) return
      compressImage(file, this.limit)
        .then((compressed) => {
          resolver.resolve(compressed)
        })
        .catch(() => {
          Message.error('图片压缩失败，请重新选择图片')
          resolver.reject(new Error('compress image failed'))
        })
    },
    onCancelCompress() {
      const resolver = this.compressResolver
      this.compressResolver = null
      this.pendingFile = null
      if (resolver) {
        resolver.reject(new Error('cancel upload'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.upload-assets__wrapper {
  .assets-uploader {
    /deep/ .el-upload {
      text-align: left;
      width: 100%;
    }
  }

  .overflow-widget {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>
